import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=230b40ba&scoped=true"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=js"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeletion.vue?vue&type=style&index=0&id=230b40ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b40ba",
  null
  
)

export default component.exports